<script>
export default {
	name: 'HistoryTabs',
	props: {
		// active tab id
		value: {
			type: String,
			default: 'shipments',
		},
		tabs: {
			type: Array,
			required: true,
		},
	},
}
</script>

<template>
	<div class="history-tabs">
		<button
			v-for="tab in tabs"
			:key="tab.id"
			type="button"
			class="history-tabs__tab"
			:class="{ 'history-tabs__tab--active': value === tab.id }"
			@click="$emit('input', tab.id)"
		>
			{{ tab.name }}
		</button>
	</div>
</template>

<style scoped>
.history-tabs {
	display: inline-flex;
	align-items: center;
	background: #f7fbff;
	border-radius: 12px;
	margin-bottom: 20px;
	overflow-x: auto;
}

.history-tabs__tab {
	border: none;
	background: transparent;
	color: #157fee;
	font-family: 'Montserrat', sans-serif;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0;
	height: 44px;
	padding: 0 16px;
	cursor: pointer;
	transition: background-color 0.15s, color 0.15s;
	outline: none;
}

.history-tabs__tab:hover {
	background: #eaf3ff;
}

.history-tabs__tab--active {
	background: #157fee;
	color: #ffffff;
}
.history-tabs__tab--active:hover {
	background: #157fee;
}
</style>
